<template>
	<!-- 顶 部 -->
	<div id="nav-bar" :class="(activeIndex == '/' || activeIndex == '-1') ? 'nav-bar' : 'nav-bar-block'" @mouseenter="hoverNav" @mouseleave="noHoverNav">
		<div class="nav-content">
			<div class="nav-logo" style="padding-top:9px;">
				
				<img style="height :2.7vw;width:10.3vw" v-show="isHover || (activeIndex != '/'  && activeIndex != '-1')   " :src="require('../assets/images/logoBlack.png') " alt="道佑律师" />
				
				
				<img style="height :2.7vw;width:10.3vw" v-show="!(isHover || (activeIndex != '/'  && activeIndex != '-1') )" :src=" require('../assets/images/logo.png')" alt="道佑律师" />
			</div>
			<!-- activeIndex{{activeIndex}} -->
			<el-menu class="nav-link el-menu-demo" :default-active="activeIndex"
				mode="horizontal" @select="handleSelect" @open="openMenu">
				
				<el-menu-item index="/" @mouseover.native="handleOver(1,'首页')"
						@mouseout.native="handleOut(1)">
					<span style="font-size:1.17vw;display: flex; align-items: center;" >
						
						<span v-if="activeIndex == '-1' && !isHover" style="color: #fff;" class="font13bold"> 首页
						</span> 
						<span v-else-if="isHover && currentHover != '首页'" style="color: #000;" class="font13bold"> 首页
						</span> 
						<span v-else-if="currentHover == '首页' || activeIndex == '/'" style="color: #1c6ce6;" class="font13bold">
							首页
						</span> 
						<span v-else style="color: #000;" class="font13bold">
							首页
						</span> 
						
						<img v-if="activeIndex == '-1' && !isHover" :src="home" />
						<img v-else-if="isHover && currentHover != '首页'" :src="homeBlack" />
						<img v-else-if="currentHover == '首页' || activeIndex == '/'" :src="homeCheck" />
						<img v-else :src="homeBlack" />
					</span>
				</el-menu-item>
			
				<el-submenu :index="index + 2 +'s'" v-for="(item,index) in treeList" :key="item.columnId" @mouseover.native="handleOverdong(item,1) "
							@mouseout.native="handleOverdong(item,2)">
					<template slot="title" >
						
						<span style="font-size:1.17vw;display: flex; align-items: center;" >
							<!-- {{getIsChoose(item) && !isHover}} -->
							<span v-if="(activeIndex == '-1' || activeIndex == '/')  && !isHover" style="color: #fff;" class="font13bold">  {{item.columnName}}
							</span> 
							<span v-else-if="isHover && currentHover != item.columnName" style="color: #000;" class="font13bold">  {{item.columnName}}
							</span> 
							<span v-else-if="currentHover == item.columnName || getIsChoose(item)" style="color: #1c6ce6;" class="font13bold">
								 {{item.columnName}}
							</span> 
							<span v-else style="color: #000;" class="font13bold">
								 {{item.columnName}}
							</span> 
							
							<img v-if="(activeIndex == '-1' || activeIndex == '/') && !isHover" :src="item.columnIcon" />
							<img v-else-if="isHover && currentHover != item.columnName" :src="item.columnIcon2" />
							<img v-else-if="currentHover == item.columnName || getIsChoose(item)" :src="item.columnIcon1" />
							<img v-else :src="item.columnIcon2" />
						</span>
					</template>
					<div style="width:100%;height:2px;background:#1C6CE6"></div>
					<el-menu-item v-for="(subItem,subIndex) in item.children" :key="subItem.columnId"
						:index="subItem.linkHref">{{subItem.columnName}}</el-menu-item>
				</el-submenu>

				<el-menu-item index="/search" @mouseover.native="handleOver(1,'搜索')"
						@mouseout.native="handleOut(1)">
					
					
					<span style="font-size:1.17vw;display: flex; align-items: center;" >
						<!-- {{getIsChoose(item) && !isHover}} -->
						<span v-if="(activeIndex == '-1' || activeIndex == '/')  && !isHover" style="color: #fff;" class="font13bold">  搜索
						</span> 
						<span v-else-if="isHover && currentHover != '搜索'" style="color: #000;" class="font13bold">  搜索
						</span> 
						<span v-else-if="currentHover == '搜索' || activeIndex=='/search'" style="color: #1c6ce6;" class="font13bold">
							 搜索
						</span> 
						<span v-else style="color: #000;" class="font13bold">
							搜索
						</span> 
						
						<img v-if="(activeIndex == '-1' || activeIndex == '/')  && !isHover" :src="searchNo" />
						<img v-else-if="isHover && currentHover != '搜索'" :src="searchBlack" />
						<img v-else-if="currentHover == '搜索' || activeIndex=='/search'"  :src="searchCheck" />
						<img v-else :src="searchBlack" />
					</span>
				</el-menu-item>
			
			</el-menu>
			<div class="nav-link" style="height:58px;margin-top:2px;    padding-left: 1.1vw;" @mouseover="handleOver(1,'电话')"
						@mouseout="handleOut(1)">
				<span style="font-size:1.17vw;display: flex; align-items: center;" >
					<!-- {{getIsChoose(item) && !isHover}} -->
					<img v-if="(activeIndex == '-1' || activeIndex == '/')  && !isHover" :src="tellNo" />
					<img v-else-if="isHover && currentHover != '电话'" :src="tellBlack" />
					<img v-else-if="currentHover == '电话' "  :src="tellCheck" />
					<img v-else :src="tellBlack" />
					<span v-if="(activeIndex == '-1' || activeIndex == '/')  && !isHover" style="color: #fff;" class="font13bold">  :4001009895
					</span> 
					<span v-else-if="isHover && currentHover != '电话'" style="color: #000;" class="font13bold">  :4001009895
					</span> 
					<span v-else-if="currentHover == '电话'" style="color: #1c6ce6;" class="font13bold">
						 :4001009895
					</span> 
					<span v-else style="color: #000;" class="font13bold">
						:4001009895
					</span> 
					
					
				</span>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		columntTreelist,
		summaryList
	} from '@/api/webstation.js'
	export default {
		props: {
			status: {
				type: String,
				required: false
			},
			// urlRou: {
			// 	type: String,
			// 	required: false
			// }
		},
		name: "Header",
		data() {
			return {
				activeIndex: "-1", // 初始选中首页
				treeList: [],
				jianJieInfo: {},
				homeNo: require('../assets/images/icon/white1.png'),
				home: require('../assets/images/icon/white1.png'),
				homeCheck: require('../assets/images/icon/blue1.png'),
				homeBlack: require('../assets/images/icon/black1.png'),
				searchNo: require('../assets/images/icon/white7.png'),
				search: require('../assets/images/icon/white7.png'),
				searchCheck: require('../assets/images/icon/blue7.png'),
				searchBlack: require('../assets/images/icon/black7.png'),
				tellNo: require('../assets/images/icon/white8.png'),
				tell: require('../assets/images/icon/white8.png'),
				tellCheck: require('../assets/images/icon/blue8.png'),
				tellBlack: require('../assets/images/icon/black8.png'),
				isHover:false,
				currentHover:''
			};
		},
		watch:{
			 $route(newVal, oldVal) {
			      console.log('11',newVal);
				   console.log('22',oldVal);
				  if(newVal.fullPath == '/login'){
					  document.getElementById("nav-bar").style.display = "none";
				  }else{
					  document.getElementById("nav-bar").style.display = "block";
				  }
				  if(!(newVal.fullPath == '/' && oldVal.fullPath == '/'))
				  {
					  this.handleSelect(newVal.fullPath)
				  }
				  
			    }
		},
		created() {
			// this.activeIndex = this.urlRou
			// this.home = this.homeCheck
			this.getsummaryList()
			 
		},
		mounted() {
			this.$nextTick(()=>{
				//console.log(window.location.pathname);
				this.getTreeList()
				// //console.log("100000",this.$route.path);
			})
		},
		methods: {
			        
			getIsChoose(item){
				var boo = false
				for (var i = 0; i < item.children.length; i++) {
					if(this.activeIndex ==item.children[i].linkHref )
					{
						boo = true
					}
				}
				 return boo
			},
		 
			openMenu(e){
				console.log('?????????e: ',e);
			},
			hoverNav(){
				this.isHover = true
			},
			noHoverNav(){
				this.isHover = false
			},
			handleOutTell(){
				if(this.activeIndex == "/"){
					this.tell = this.tellNo
				}else{
					this.tell = this.tellBlack
				}
			},
			handleOverdong(item,type){
				if(type == 1)
				{
					this.currentHover=item.columnName
					console.log("currentHover",this.currentHover);
				}
				else{
					this.currentHover= ''
				}
				
				// var falg = false;
				// for (var i = 0; i < item.children.length; i++) {
				// 	var obj = item.children[i];
				// 	if(obj.linkHref === this.activeIndex){
				// 		falg = true;
				// 	}
				// }
				
				// if(falg){
				// 	return ;
				// }
				// //console.log(item);
				// if(type == 1){
				// 	item.columnIcon = item.columnIcon1
				// }else{
				// 	if(this.activeIndex == "/"){
				// 		item.columnIcon = item.originalIcon
				// 	}else{
				// 		item.columnIcon = item.columnIcon2
				// 	}
				// }
			},
			// handleOutdong(item){
			// 	var falg = false;
			// 	for (var i = 0; i < item.children.length; i++) {
			// 		var obj = item.children[i];
			// 		if(obj.linkHref === this.activeIndex){
			// 			falg = true;
			// 		}
			// 	}
				
			// 	if(falg){
			// 		return ;
			// 	}
			// },
			handleOver(type,index){
				console.log('index: ',index);
				this.currentHover=index
				
			},
			handleOut(type){
				this.currentHover=''
				
			},
			getTreeList() {
				let that = this
				columntTreelist({

				}).then(res => {
					if (res.code == 200) {
						that.treeList = res.data


						that.treeList.forEach((obj) => {
							if (obj.columnName === '加入合作') {
								obj.originalIcon = obj.columnIcon
								obj.columnIcon1 = require('../assets/images/icon/blue2.png')
								obj.columnIcon2 = require('../assets/images/icon/black2.png')
							} else if (obj.columnName === '科技布局') {
								obj.originalIcon = obj.columnIcon
								obj.columnIcon1 = require('../assets/images/icon/blue3.png')
								obj.columnIcon2 = require('../assets/images/icon/black3.png')
							} else if (obj.columnName === 'E.S.G') {
								obj.originalIcon = obj.columnIcon
								obj.columnIcon1 = require('../assets/images/icon/blue4.png')
								obj.columnIcon2 = require('../assets/images/icon/black4.png')
							} else if (obj.columnName === '关于我们') {
								obj.originalIcon = obj.columnIcon
								obj.columnIcon1 = require('../assets/images/icon/blue5.png')
								obj.columnIcon2 = require('../assets/images/icon/black5.png')
							} else if (obj.columnName === '下载和关注') {
								obj.originalIcon = obj.columnIcon
								obj.columnIcon1 = require('../assets/images/icon/blue6.png')
								obj.columnIcon2 = require('../assets/images/icon/black6.png')
							}
							
						});
						// this.handleSelect(this.$route.fullPath)
					}
				})
			},
			getsummaryList() {
				let that = this
				summaryList({
					"pageNum": "1",
					"pageSize": "1",
					"showModel": '1'
				}).then(res => {
					if (res.code == 200) {
						that.jianJieInfo = res.rows[0]

					}
				})
			},
			handleSelect(key) {
				//console.log(key);
				if(key ==null){
					return ;
				}
				// this.home = this.homeNo
				this.search = this.searchNo
				this.$router.push({
					path: key
				});
				if(key == "/"){
					// this.home = this.homeCheck
					this.tell = this.tellNo
				}else{
					// this.home = this.homeBlack
					this.tell = this.tellBlack
					this.search = this.searchBlack
				}
				if(key == "/search"){
					this.search = this.searchCheck
				}
				var  num = -1;
				for (var i = 0; i < this.treeList.length; i++) {
					var children = this.treeList[i];
					
					for (var j = 0; j < children.children.length; j++) {
						var obj = children.children[j];
						// //console.log(obj.linkHref === key);
						if (obj.linkHref.indexOf(key) != -1) {
							if(key == "/cooperate" || key == "/affairs"){
								num = 0;
							}
							if(key.indexOf("/layout")!=-1){
								num = 1
							}
							if(key.indexOf("/esg")!=-1){
								num = 2
							}
							if(key.indexOf("/about")!=-1 || key.indexOf("/serveStart")!=-1){
								num = 3
							}
							if(key.indexOf("/upload")!=-1){
								num = 4
							}
						}
						if(key == "/"){
							this.$set(children,"columnIcon",children.originalIcon)
						}else{
							this.$set(children,"columnIcon",children.columnIcon2)
						}
					}
				}
				
				if(num == 0){
					this.$set(this.treeList[num],"columnIcon",require('../assets/images/icon/blue2.png'))
				}else if(num == 1){
					this.$set(this.treeList[num],"columnIcon",require('../assets/images/icon/blue3.png'))
				}else if(num == 2){
					this.$set(this.treeList[num],"columnIcon",require('../assets/images/icon/blue4.png'))
				}else if(num == 3){
					this.$set(this.treeList[num],"columnIcon",require('../assets/images/icon/blue5.png'))
				}else if(num == 4){
					this.$set(this.treeList[num],"columnIcon",require('../assets/images/icon/blue6.png'))
				}
				//console.log(this.treeList);
				
				this.$nextTick(()=>{
					this.$set(this, 'activeIndex', key);
					//console.log('this.activeIndex: ', this.activeIndex);
				})
			}
		}
	}
</script>

<style>
	/* 导航栏样式 */
	.nav-bar {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		z-index: 1000;
		transition: all 0.3s ease;
		background-color:transparent;
	}
	
	.nav-bar  .el-menu--horizontal>.el-menu-item{
		color: #fff;
	}
	.nav-bar  .el-submenu__title {
		color: #fff !important;
	
	}
	.nav-bar-block{
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		z-index: 1000;
		transition: all 0.3s ease;
		background-color:#fff;
	}
	
	.nav-bar-block  .el-menu--horizontal>.el-menu-item{
		color: #000 ;
	}
	.nav-bar-block  .el-submenu__title {
		color: #000 !important;
	
	}

.nav-bar:hover{
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		z-index: 1000;
		transition: all 0.3s ease;
		background-color: #fff;
	}
	.nav-bar:hover  .el-menu--horizontal>.el-menu-item{
		color: #000 ;
	}
	.nav-bar:hover  .el-submenu__title {
		color: #000 !important;
	
	}
	
	.nav-bar.nav-scrolled {
		background-color: #fff;
		box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
	}

	.nav-content {
		/* width: 85%; */
		/* margin: 0 auto; */
		    margin-left: 8vw ;
		    margin-right: 0vw;
		display: flex;
		/* justify-content: space-between; */
		align-items: center;
		padding-top: 30px;
	}

	.nav-logo img {
		height: 42px;
		width: auto;
		margin-right: 20px;
	}

	.nav-links {
		display: flex;
		gap: 30px;
		align-items: center;
	}

	.nav-link {
		color: #fff;
		text-decoration: none;
		font-size: 16px;
		transition: all 0.3s;
		cursor: pointer;
		display: flex;
		align-items: center;
		font-weight: bold;

	}

	.nav-scrolled .nav-link {
		color: #fff;
	}

	.nav-link:hover {
		color: #1c6ce6;
	}

	.nav-link img {
		width: auto;
		height: 22px;
	}
	.textColor{
		color:#fff;
	}
	.textColorN{
		color:#000;
	}
	.textColor:hover{
		color:#1c6ce6;
	}
	.textColorN:hover{
		color:#1c6ce6;
	}
	
	.font13bold{
		font-size: 1.17vw;
		font-weight: bold;
	}
</style>


// WEBPACK FOOTER //
// src/components/Header.vue